module.exports = __webpack_public_path__ + "static/media/ampm.34ec1553.png";